import { addUrlParams } from "../util/UrlHelper";
import { getUrlOrigin } from "../util/ContextHelper";
import configuration from "../Configuration";

class FetchClient
{
    public defaultHeaders = {};

    private async baseFetch<T = void>(method: string, url: string, body?: string, preview?: boolean): Promise<T>
    {
        const previewHeader = preview ? { "Preview": "true" } : { "Preview": "false" };
        const response = await globalThis.fetch(url,
            {
                method,
                headers: { ...this.defaultHeaders, ...previewHeader },
                body
            });

        return await response.json() as T;
    }

    public async fetchDelete<T = void>(url: string): Promise<T>
    {
        return await this.baseFetch("DELETE", url, undefined);
    }

    public async fetchGet<T>(url: string, preview?: boolean): Promise<T>
    {
        return await this.baseFetch("GET", url, undefined, preview);
    }

    public async fetchPut<T>(url: string, body: object): Promise<T>
    {
        return await this.baseFetch("PUT", url, JSON.stringify(body));
    }

    public async fetchPost<T>(url: string, body: object): Promise<T>
    {
        return await this.baseFetch("POST", url, JSON.stringify(body));
    }

    public urlBuilder(request: string, params?: UrlParams): URL
    {
        let base = configuration.baseURL;
        if (base === "/")
        {
            base = getUrlOrigin();
        }

        let url = new URL(request, base);
        if (params)
        {
            url = addUrlParams(url, params);
        }
        return url;
    }
}

export default FetchClient;